import {defineRule, configure} from 'vee-validate';
import {required, email, min, digits, alpha, numeric} from '@vee-validate/rules';

export const convertPersianToEnglish = (value) => {
  if (!value) return '';
  const str = String(value);
  return str
    .replace(/[۰-۹]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1728))
    .replace(/[٠-٩]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1584));
};

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('digits', digits);
defineRule('alpha', alpha);
defineRule('numeric', numeric);
defineRule('password_custom', (value) => {
  const englishValue = convertPersianToEnglish(value);
  return /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{}|;:,.<>?]+$/.test(englishValue) || 'اعداد، حروف و نمادها مجاز هستند';
});
defineRule('name', (value) => {
  return /^[a-zA-Z\s]+$/.test(value) || 'از کلمات استفاده کنید';
});

defineRule('phone', (value) => {
  const englishValue = convertPersianToEnglish(value);
  if (!/^09/.test(englishValue)) {
    return 'شماره همراه با 09 شروع میشود';
  }
  if (!/^\d{11}$/.test(englishValue)) {
    return 'شماره همراه باید 11 رقم باشد';
  }
  return true;
});

defineRule('alpha_custom', (value) => {
  if (value.length < 3) {
    return 'حداقل سه حرف باشد';
  }
  return /^[a-zA-Z0-9\u0600-\u06FF\s]+$/.test(value) || 'فقط حروف و اعداد مجاز هستند';
});

defineRule('confirmed', (value, [target], ctx) => {
  return value === ctx.form[target] || 'رمزهای عبور مطابقت ندارند';
});

configure({
  generateMessage: (ctx) => {
    const messages = {
      required: 'این بخش نباید خالی باشد',
      email: 'ایمیل فرمت درستی ندارد',
      min: 'حداقل 8 کرکتر باید باشد',
      confirmed: 'رمزهای عبور مطابقت ندارند',
      alpha: 'فقط حروف مجاز هستند',
      numeric: 'فقط اعداد مجاز هستند',
      password: 'فقط حروف انگلیسی و نمادها مجاز هستند',
      phone: 'شماره همراه باید 11 رقم باشد',
      alpha_custom: 'فقط حروف و اعداد مجاز هستند',
    };
    return messages[ctx.rule.name] || `The field ${ctx.field} is invalid`;
  },
});

export const useValidationRules = () => {
};
